import {
  resolveBrowserHref,
  type BrowserRef,
} from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

/** Um atalho da faixa, como o `ObjectListWidget` grava. */
export interface SubHomeDestaqueItem {
  /** Gerado pelo `ObjectListWidget`; serve de `key` estável na lista. */
  '@id'?: string;
  label?: string;
  href?: BrowserRef[];
  external?: boolean;
}

/** Dados do bloco `mpfSubHomeDestaque`. */
export interface SubHomeDestaqueData {
  title?: string;
  items?: SubHomeDestaqueItem[];
}

/** View-model de um atalho. */
export interface SubHomeDestaqueLink {
  key: string;
  /** Posição em `items` — é o que o lápis passa ao editor. */
  sourceIndex: number;
  label: string;
  href?: string;
  external?: boolean;
}

/** Título padrão da faixa, quando o editor não escreve um. */
export const SUBHOME_DESTAQUE_TITLE = 'Destaque';

/**
 * Teto de atalhos. Três por linha em `lg`, então seis fecham duas linhas
 * cheias; acima disso a faixa deixa de ser um punhado de atalhos e vira
 * lista, que é papel do bloco de Conteúdos Relacionados.
 */
export const SUBHOME_DESTAQUE_MAX_ITEMS = 6;

/**
 * Devolve TODOS os atalhos até o teto, inclusive os incompletos.
 *
 * O filtro fica com a View, e não aqui: no editor o item pela metade precisa
 * continuar na tela, senão o lápis dele some justo enquanto está sendo
 * preenchido. Ver `subHomeDestaqueLinkIsComplete`.
 */
export const toSubHomeDestaqueLinks = (
  items?: SubHomeDestaqueItem[],
): SubHomeDestaqueLink[] =>
  (items ?? []).slice(0, SUBHOME_DESTAQUE_MAX_ITEMS).map((item, index) => ({
    key: item['@id'] ?? `destaque-${index}`,
    sourceIndex: index,
    label: item.label ?? '',
    href: resolveBrowserHref(item.href),
    external: item.external,
  }));

/**
 * Atalho sem rótulo ou sem destino não vira botão no site: o primeiro seria
 * um retângulo vazio, o segundo um link que não leva a lugar nenhum.
 */
export const subHomeDestaqueLinkIsComplete = (
  link: SubHomeDestaqueLink,
): boolean => !!link.label && !!link.href;
